const REEL_FRAME_WIDTH_UNIT = 9;
const REEL_FRAME_HEIGHT_UNIT = 16;

export interface QuantizedReelFrameSize {
	width: number;
	height: number;
	k: number;
}

function toFiniteAvailableSize(value: number): number {
	return Number.isFinite(value) ? Math.max(0, value) : 0;
}

export function quantizeReelFrameSize(
	availableWidth: number,
	availableHeight: number
): QuantizedReelFrameSize {
	const maxKByWidth = Math.floor(
		toFiniteAvailableSize(availableWidth) / REEL_FRAME_WIDTH_UNIT
	);
	const maxKByHeight = Math.floor(
		toFiniteAvailableSize(availableHeight) / REEL_FRAME_HEIGHT_UNIT
	);
	const k = Math.max(1, Math.min(maxKByWidth, maxKByHeight));

	return {
		width: REEL_FRAME_WIDTH_UNIT * k,
		height: REEL_FRAME_HEIGHT_UNIT * k,
		k
	};
}
